module.exports = __webpack_public_path__ + "static/media/Rasula.4c8fd3eb.jpg";